import { createRouter } from '@tanstack/react-router';

import { type AuthContext } from './auth-context';
import { routeTree } from './routes';

/**
 * SCRUM-616 — the single router instance. Created ONCE with a placeholder auth
 * context; the live value is injected every render by <RouterProvider
 * context={{ auth }} /> in App.tsx (official TanStack pattern for auth held
 * outside the router). `defaultPreload: 'intent'` is inert today (routes have
 * no data loaders — pages fetch via React Query in components) but is kept for
 * future benefit.
 */
export const router = createRouter({
  routeTree,
  context: {
    // Placeholder — always overwritten by RouterProvider's context prop before
    // first paint. Never actually read (InnerApp injects the real value). Cast
    // rather than a non-null assertion to satisfy the lint config.
    auth: {} as AuthContext,
  },
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
